<template>
  <div class="order-wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    
    <div class="search-section card-shadow">
      <el-form
          ref="form"
          inline
          :model="searchData"
          label-width="80px"
          class="search-form"
      >
        <el-form-item label="订单号">
          <el-input
              size="small"
              v-model="searchData.order_no"
              placeholder="请输入订单号"
              class="custom-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input
              size="small"
              v-model="searchData.company_name"
              placeholder="请输入企业名称"
              class="custom-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
              size="small"
              v-model="searchData.mobile"
              placeholder="请输入手机号码"
              class="custom-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select
              v-model="searchData.pay_type"
              placeholder="请选择支付方式"
              size="small"
              clearable
              class="custom-select"
          >
            <el-option label="微信支付" :value="20"></el-option>
            <el-option label="微信扫码支付" :value="40"></el-option>
            <el-option label="支付宝扫码支付" :value="50"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
              size="small"
              v-model="searchData.product_name"
              placeholder="请输入商品名称"
              class="custom-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工">
          <el-cascader
              v-model="searchData.agent_employee_ids"
              :options="agentEmployeeTreeData"
              :show-all-levels="false"
              clearable
              size="small"
              class="custom-cascader"
              placeholder="请选择员工"
          ></el-cascader>
        </el-form-item>
        <el-form-item class="btn-group">
          <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="getList"
              class="custom-btn"
          >搜索
          </el-button>
          <el-button
              type="info"
              size="small"
              icon="el-icon-refresh"
              @click="reset"
              class="custom-btn"
          >重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="order-tabs">
      <div
          v-for="tab in tabs"
          :key="tab.value"
          :class="['tab-item', searchData.pay_status === tab.value ? 'active' : '']"
          @click="handleClickTab(tab.value)"
      >
        <el-badge>
          <span class="tab-name">{{ tab.label }}</span>
        </el-badge>
      </div>
    </div>

    <div class="table-container card-shadow">
      <el-table 
          :data="list"
          stripe
          border
          v-loading="loading"
          class="custom-table"
      >
        <el-table-column prop="order_no" label="订单编号" min-width="160">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleDetail(row)">{{ row.order_no }}</el-link>
          </template>
        </el-table-column>
        
        <el-table-column label="订单金额" min-width="120" align="right">
          <template slot-scope="{ row }">
            <span class="money-text">￥{{ formatMoney(row.pay_price) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="pay_type_dsc" label="支付方式" min-width="140">
          <template slot-scope="{row}">
            <el-tag size="small" type="info">{{ row.pay_type_dsc }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="付款状态" min-width="100">
          <template slot-scope="{ row }">
            <el-tag
                size="small"
                :type="row.pay_status === 20 ? 'success' : 'warning'"
            >{{ row.pay_status_dsc }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="商品信息" min-width="280">
          <template slot-scope="{ row }">
            <div class="info-card product-info">
              <div class="info-item" v-if="row.product_id">
                <i class="el-icon-goods info-icon"></i>
                <span class="label">商品ID：</span>
                <span class="value">{{ row.product_id }}</span>
              </div>
              <div class="info-item">
                <i class="el-icon-shopping-bag-1 info-icon"></i>
                <span class="label">商品名称：</span>
                <span class="value">{{ row.product_name }}</span>
              </div>
              <div class="info-item" v-if="row.product_id">
                <i class="el-icon-price-tag info-icon"></i>
                <span class="label">商品价格：</span>
                <span class="value money-text">￥{{ formatMoney(row.price) }}/{{ row.year }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="用户信息" min-width="280">
          <template slot-scope="{ row }">
            <div class="info-card user-info" v-if="row.user">
              <div class="info-item">
                <i class="el-icon-user info-icon"></i>
                <span class="label">用户ID：</span>
                <el-link
                    type="primary"
                    @click="$router.push({ name: 'CustomerList', query: { id: row.user.id } })"
                >{{ row.user.id }}
                </el-link>
              </div>
              <div class="info-item">
                <i class="el-icon-user-solid info-icon"></i>
                <span class="label">用户昵称：</span>
                <span class="value">{{ row.user?.company_name }}</span>
              </div>
              <div class="info-item">
                <i class="el-icon-mobile-phone info-icon"></i>
                <span class="label">手机号码：</span>
                <span class="value">{{ row.user?.mobile }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="员工信息" min-width="280">
          <template slot-scope="{ row }">
            <div class="info-card employee-info" v-if="row.agent_employee">
              <div class="info-item">
                <i class="el-icon-s-custom info-icon"></i>
                <span class="label">员工ID：</span>
                <el-link
                    type="primary"
                    @click="$router.push({ name: 'CustomerList', query: { id: row.user.id } })"
                >{{ row.agent_employee.id }}
                </el-link>
              </div>
              <div class="info-item">
                <i class="el-icon-user info-icon"></i>
                <span class="label">姓名：</span>
                <span class="value">{{ row.agent_employee?.account }}</span>
              </div>
              <div class="info-item">
                <i class="el-icon-phone info-icon"></i>
                <span class="label">手机号码：</span>
                <span class="value">{{ row.agent_employee?.mobile }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="pay_date" label="支付时间" min-width="180"></el-table-column>
        <el-table-column prop="created_at" label="创建日期" min-width="180"></el-table-column>

        <el-table-column
            label="操作"
            width="120"
            fixed="right"
            align="center"
        >
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="small"
                @click="handleDetail(row)"
                class="action-btn"
            >
              <i class="el-icon-view"></i> 详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
          :total="total"
          :page.sync="searchData.page"
          :limit.sync="searchData.pagesize"
          @pagination="getList"
          class="custom-pagination"
      />
    </div>

    <el-drawer
        size="45%"
        :visible.sync="show_detail"
        direction="rtl"
        :destroy-on-close="true"
        custom-class="custom-drawer"
    >
      <Detail :detail="detail"></Detail>
    </el-drawer>
  </div>
</template>

<script>
import {getListAPI, delAPI, addAPI, editAPI, getDetailAPI, changeStatusAPI} from './api'
import {authBtnMixin} from '@/mixins/authBtnMixin'
import Detail from './detail.vue'
import {getAgentEmployeeTreeAPI} from "@/views/user/api";

export default {
  name: 'Index',
  mixins: [authBtnMixin],
  components: {Detail},
  data() {
    return {
      rules: [{required: true, message: '该项不能为空', trigger: 'blur'}],
      show_detail: false,
      show_review: false,
      list: [],
      city_list: [],
      // 添加tabs定义
      tabs: [
        { label: '全部', value: null, count: 0 },
        { label: '待支付', value: 10, count: 0 },
        { label: '已支付', value: 20, count: 0 },
        { label: '已取消', value: 30, count: 0 },
        { label: '已退款', value: 40, count: 0 }
      ],
      agentEmployeeTreeData: [],
      searchData: {
        order_type: 10,
        page: 1,
        pagesize: 10,
        order_no: '',
        mobile: '',
        product_name: '',
        company_name: '',
        agent_employee_ids: [],
        pay_type: null,
        pay_status: null
      },
      total: 0,
      changeStatusData: {
        id: '',
        status: null
      }
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.getList()
    this.getAgentEmployeeTree()
  },

  methods: {
    async getAgentEmployeeTree() {
      // 获取get 参数
      this.agentEmployeeTreeData = await getAgentEmployeeTreeAPI()
    },
    // 详情
    async handleDetail({id}) {
      this.detail = await getDetailAPI(id)
      this.show_detail = true
    },
    handleClickTab(val) {
      if (this.searchData.pay_status == val) return
      this.searchData.pay_status = val
      this.getList()
    },
    // 审核弹窗
    getStatus(row) {
      this.changeStatusData = {
        id: row.id,
        status: row.status
      }
      this.show_review = true
    },
    changeStatus() {
      changeStatusAPI(this.changeStatusData).then(() => {
        this.$message.success('提交成功')
        this.getList()
        this.show_review = false
      })
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async getList() {
      this.loading = true;
      try {
        let params = {...this.searchData}
        const res = await getListAPI(params)
        this.list = res.data || []
        this.total = res.total || 0
        
        // 更新tab计数
        if (res.statistics) {
          this.tabs = this.tabs.map(tab => ({
            ...tab,
            count: res.statistics[tab.value] || 0
          }))
        }
      } catch (error) {
        console.error('获取列表失败：', error)
      } finally {
        this.loading = false
      }
    },
    // del
    async handleDel({id}) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delAPI(id).then(() => {
              this.$message.success('删除成功')
              this.getList()
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
    },
    // 新增
    handleAdd() {
      this.show_update = true
      this.$nextTick(() => {
        this.formData = {
          name: '',
          icon: '',
          describe: ''
        }
        this.$refs.form.resetFields()
      })
    },
    // edit
    async handleEdit({id}) {
      this.show_update = true
      this.$nextTick(async () => {
        this.formData = await getDetailAPI(id)
        this.$refs.form.resetFields()
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.getList()
              this.show_update = false
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('添加成功')
              this.getList()
              this.show_update = false
            })
          }
        }
      })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.order-wrapper {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .card-shadow {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .search-section {
    padding: 24px;
    margin-bottom: 20px;

    .search-form {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      .el-form-item {
        margin-bottom: 0;
        margin-right: 0;
      }

      .custom-input,
      .custom-select,
      .custom-cascader {
        width: 220px;
      }

      .btn-group {
        margin-left: auto;
      }

      .custom-btn {
        transition: all 0.3s;
        margin-left: 8px;

        &:hover {
          transform: translateY(-1px);
        }
      }
    }
  }

  .order-tabs {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 16px;
    background: #fff;
    border-radius: 8px;
    height: 56px;

    .tab-item {
      position: relative;
      padding: 8px 24px;
      cursor: pointer;
      transition: all 0.3s;
      color: #606266;
      font-size: 14px;

      &:hover {
        color: #409EFF;
      }

      &.active {
        color: #409EFF;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 24px;
          height: 3px;
          background: #409EFF;
          border-radius: 2px;
        }
      }

      .el-badge__content {
        background-color: #909399;
      }
    }
  }

  .table-container {
    padding: 20px;

    .custom-table {
      margin-bottom: 20px;

      .money-text {
        color: #67C23A;
        font-weight: 500;
      }

      .info-card {
        padding: 8px;
        border-radius: 4px;

        .info-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          
          &:last-child {
            margin-bottom: 0;
          }

          .info-icon {
            margin-right: 8px;
            font-size: 16px;
            color: #909399;
          }

          .label {
            color: #606266;
            margin-right: 8px;
            font-size: 13px;
          }

          .value {
            color: #303133;
            font-size: 13px;
          }
        }
      }

      .action-btn {
        padding: 8px 16px;
        font-size: 13px;

        &:hover {
          color: #66b1ff;
        }

        i {
          margin-right: 4px;
        }
      }
    }

    .custom-pagination {
      padding: 10px 0;
      text-align: right;
    }
  }
}

.custom-drawer {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 16px;
    font-weight: 500;
  }

  .el-drawer__body {
    padding: 20px;
  }
}
</style>
